import { Trans, useLingui } from "@lingui/react/macro";
import { useState } from "react";

import { Button } from "../../../components/ui-kit/button";
import { CopyButton } from "../../../components/ui-kit/copy-button";
import { Checkbox } from "../../../components/ui-kit/fields/checkbox";
import { downloadFile } from "../../../utils/download";

export function BackupCodes({
  codes,
  onContinue,
}: {
  codes: string[];
  onContinue: () => void;
}) {
  const { t } = useLingui();
  const [saved, setSaved] = useState(false);
  const codesText = codes.join("\n");

  return (
    <div className="flex flex-col items-center" data-testid="mfa-backup-codes">
      <h2 className="text-xl font-semibold">
        <Trans>Save your backup codes</Trans>
      </h2>

      {/* Capped on its own — the column widens to fit the codes. */}
      <p className="text-sm text-center mt-4 max-w-96">
        <Trans>
          Each code can be used once to log in if you lose access to your other
          methods. This is the only time they are shown.
        </Trans>
      </p>

      {/* Grid tracks wrap their content rather than overflow, so the two
          columns (~446px wide) stack below that instead of breaking a code. */}
      <div className="grid grid-cols-1 min-[480px]:grid-cols-2 gap-x-6 gap-y-1 mt-4 font-mono text-sm">
        {codes.map((code) => (
          <span key={code}>{code}</span>
        ))}
      </div>

      <div className="flex gap-2 mt-4">
        <CopyButton
          value={codesText}
          label={t`Copy codes`}
          copiedLabel={t`Codes copied`}
        />
        <Button
          onClick={() => {
            downloadFile(
              new Blob([`${codesText}\n`], { type: "text/plain" }),
              "seerlinq-backup-codes.txt",
            );
          }}
        >
          <Trans>Download codes</Trans>
        </Button>
      </div>

      <label className="flex items-center gap-2 mt-6">
        <Checkbox value={saved} onChange={setSaved} />
        <span className="text-sm">
          <Trans>I have saved these codes</Trans>
        </span>
      </label>

      <Button
        variant="primary"
        className="mt-4"
        disabled={!saved}
        onClick={onContinue}
      >
        <Trans>Continue</Trans>
      </Button>
    </div>
  );
}
